import React, { Component } from 'react';
import { tipoImpressaoCupom } from '../../util/constantsUtil';

export default class ModalImpressaoListaPassageiro extends Component {

    exibirBotaoImprimir () {      
      return (
          <button  disabled={!this.props.pagina}
              onClick={() => this.props.pagina.print()}
              className="btn btn-laranja">IMPRIMIR</button>
      )
    }

    limparTudo() {        
        this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal);
        this.props.habilitarDesabilitarReciboCupomEncomenda(false);
      }

    render() {
        return (<div className="modal fade show" id='modalImpressaoListaPassageiro' role='dialog'
             aria-labelledby='modalImpressaoListaPassageiro' aria-hidden='true' data-backdrop='static'>
          <div className={'modal-dialog modal-dialog-centered modal-md'}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Selecione o tipo de impressão que deseja</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => this.limparTudo()}>
                  <i className="material-icons">
                    &#xe5cd;
                  </i>
                </button>
              </div>
              <div className="modal-body">                
                <input type="radio" onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal)}
                    checked={this.props.tipo === tipoImpressaoCupom.normal} /> Normal <br/>
                <input type="radio" onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.resumida)}
                    checked={this.props.tipo === tipoImpressaoCupom.resumida}/> Resumida                
              </div>
              <div className="modal-footer">
                {this.exibirBotaoImprimir()}
              </div>
            </div>
          </div>
        </div>);
    }
}